import { render } from "./AboutCN.vue?vue&type=template&id=e2c31926&scoped=true"
import script from "./AboutCN.vue?vue&type=script&lang=js"
export * from "./AboutCN.vue?vue&type=script&lang=js"

import "./AboutCN.vue?vue&type=style&index=0&id=e2c31926&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c31926"]])

export default __exports__